/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {BemerkungDialogController} from '../../../core/dialog/BemerkungDialogController';
import {OkCancelController} from '../../../core/dialog/OkCancelController';
import {RemoveDialogController} from '../../../core/dialog/RemoveDialogController';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import ErrorService from '../../../core/errors/service/ErrorService';
import AnlaufstelleRS from '../../../core/service/AnlaufstelleRS.rest';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import DokumenteRS from '../../../core/service/dokumenteRS.rest';
import RoleUtilService from '../../../core/service/RoleUtilService';
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import StatuswechselService from '../../../core/service/StatuswechselService';
import {TSBegruendungsCode} from '../../../models/enums/TSBegruendungsCode';
import {TSBemerkungScope} from '../../../models/enums/TSBemerkungScope';
import {TSRechtsform} from '../../../models/enums/TSRechtsform';
import {TSRole} from '../../../models/enums/TSRole';
import {TSSchadenfallEvent} from '../../../models/enums/TSSchadenfallEvent';
import {getTSSchadenfallStatusalues, getTSSchadenfallStatusNeu, TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import TSBenutzer from '../../../models/TSBenutzer';
import TSSchaden from '../../../models/TSSchaden';
import TSSchadenDaten from '../../../models/TSSchadenDaten';
import TSSchadenfall from '../../../models/TSSchadenfall';
import TSSchadenfallDaten from '../../../models/TSSchadenfallDaten';
import TSSchadenObjektDaten from '../../../models/TSSchadenObjektDaten';
import TSStatuswechsel from '../../../models/TSStatuswechsel';
import DVBernUtil from '../../../utils/DVBernUtil';
import {IFallStateParams, ISchadenStateParams} from '../../gesuch.route';
import AbstractModelManagerController from '../abstractModelManagerController';
import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

declare let require: any;
declare let angular: any;

let template = require('./schadenfallView.html');
let removeDialogTemplate = require('../../../core/dialog/removeDialogTemplate.html');
let bemerkungDialogTemplate = require('../../../core/dialog/bemerkungDialogTemplate.html');
let okCancelTemplate = require('../../../core/dialog/okCancelTemplate.html');

export class SchadenfallViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = SchadenfallViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        schadenfall: '<',
    };
}

export class SchadenfallViewController extends AbstractModelManagerController<TSSchadenfall> {
    static $inject = [
        'DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$window', '$state',
        'DvDialog', 'AuthServiceRS', 'RoleUtilService', 'BenutzerRS', 'AnlaufstelleRS', '$log', 'StatuswechselService', 'ErrorService', 'DokumenteRS',
    ];
    schadenfall: TSSchadenfall; //do not use in binding when editing model data, use this.model instead
    form: IFormController;
    selectedSchaden: TSSchaden | undefined;
    forms: any = {};
    scopeToShow: Array<TSBemerkungScope> = [];
    scope: TSBemerkungScope = TSBemerkungScope.SCHADENFALL;
    checklistValid: boolean = false;
    ereignisWasSaved: boolean = false;

    statuswechsel: TSStatuswechsel | undefined;

    schadenfallEvent: TSSchadenfallEvent | undefined;  //event der bei freigabe getriggered werden soll

    possibleSchaetzer: Array<TSBenutzer>;

    selectedSchaetzer: TSBenutzer | undefined;

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil, schadenfallModelManager: SchadenfallModelManager,
                private $q: IQService,
                $scope: IScope, private $translate: ITranslateService, private $window: any,
                private $state: IStateService, private dvDialog: DvDialog, private authServiceRS: AuthServiceRS,
                private roleUtilService: RoleUtilService, private benutzerRS: BenutzerRS,
                private anlaufstelleRS: AnlaufstelleRS,
                private $log: ILogService, private statuswechselService: StatuswechselService,
                private errorService: ErrorService, private dokumenteRS: DokumenteRS,
    ) {
        super(schadenfallModelManager, $scope, $state.current.name);
    }

    private resetView() {
        this.form.$setPristine();
        this.form.$setUntouched();
    }

    $onInit() {
        super.$onInit();
        this.loadSchaden();

        if (!this.schadenfall) {
            console.error('no schadenfall passed to view');
        } else {
            this.initialModel = this.schadenfall;
            this.model = angular.copy(this.schadenfall);
        }

        if (!this.model.schadenfallDatenFS) {
            this.model.schadenfallDatenFS = new TSSchadenfallDaten();
        }
        if (this.model.schadenfallDatenFS!.titel != null &&
            this.model.schadenfallDatenFS!.gemeinde!.name != null) {

            this.ereignisWasSaved = true;
        }

        // Show only Bemerkungen from Scope SCHADENFALL
        this.scopeToShow.push(TSBemerkungScope.SCHADENFALL);
        this.statuswechsel = this.statuswechselService.getStatuswechselMetadata(this.model.status, this.model.erfassungsart);

        this.loadPossibleSchaetzer();
    }

    private loadSchaden() {
        if (!this.hasSchaeden()) {
            this.schadenfall.schaeden[0] = this.createSchaden();
        }
    }

    public getSchadenName(index: string): string {
        return this.$translate.instant('SCHADEN') + ' ' + index;

    }

    private selectSchaden(selected: any) {
        this.selectedSchaden = this.schadenfall.schaeden[selected];
    }

    private isSchadenActive(index: any): boolean {
        return true;
    }

    private getSelectedSchaden(): TSSchaden | undefined {
        return this.selectedSchaden;
    }

    private createSchaden(): TSSchaden {
        let schaden = new TSSchaden();
        schaden.schadenDatenFS = new TSSchadenDaten();
        schaden.schadenDatenFS.schadenObjektDaten = new TSSchadenObjektDaten();
        return schaden;
    }

    private hasSchaeden(): boolean {
        return this.schadenfall.schaeden && this.schadenfall.schaeden.length > 0;
    }

    /**
     * todo: homa aulsagern
     * Diese Methode prueft ob das Form valid ist. Sollte es nicht valid sein wird das erste fehlende Element gesucht
     * und fokusiert, damit der Benutzer nicht scrollen muss, um den Fehler zu finden.
     * Am Ende wird this.form.$valid zurueckgegeben
     */
    public isGesuchValid(): boolean {
        if (this.isSchadenformValid()) {
            if (!this.form.$valid) {
                DVBernUtil.focusFirstInvalidInput()
            }
            return this.form.$valid;
        }
        return false;
    }

    private isSchadenformValid(): boolean {
        //check validity of form and show error messages if invalid
        let form: IFormController = this.form;

        if (!form.$valid) {
            form.$getControls().forEach((control: any) => {
                    if ('$validate' in control) {
                        control.$validate();
                    }
                },
            );
            form.$setSubmitted();

            DVBernUtil.focusFirstInvalidInput()
            return false;
        }
        return true;
    }

    public deleteSchaden(schaden: TSSchaden, event: any): void {
        if (schaden && this.schadenfall) {
            this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
                text: '',
                title: 'SCHADEN_LOESCHEN',
            }).then(() => {   //User confirmed removal
                this.schadenfallModelManager.deleteSchaden(this.schadenfall, schaden);
            }).catch(() => {
                console.error('error could not delete schaden');
            });
        }
    }

    public editSchaden(schaden: TSSchaden, event: any): void {
        let params: ISchadenStateParams;
        params = {schadenfallId: this.schadenfall.id, schadenId: schaden.id, schaden: schaden};
        this.$state.go('schaden', params);
    }

    public isSchadenFallNeuOnline(initialModel: boolean) {
        let model = initialModel ? this.initialModel : this.model;
        if (model.status) {
            return model.status === TSSchadenfallStatus.NEU;   //papier hat neu_papier
        }
        return false;
    }

    public isSchadenFallNeu() {
        if (this.model.status) {
            return getTSSchadenfallStatusNeu().includes(this.model.status);
        }
        return false;
    }

    private beenden() {
        this.errorService.clearAll();
        if (this.isGesuchValid() && this.model) {

            if (this.isSchadenFallNeuOnline(false)) {
                this.dvDialog.showDialog(okCancelTemplate, OkCancelController, {
                    text: 'SCHADENFALL_BEENDEN_SPEICHERN_TEXT',
                    title: 'SCHADENFALL_BEENDEN_SPEICHERN_TITLE',
                }).then(() => {   //User confirmed
                    this.save();
                });
            } else {
                this.save();
            }
        }
    }

    private save() {
        this.schadenfallModelManager.saveSchadenfall(this.model).then(() => {
            this.schadenfallModelManager.saveSchaden(this.model.schaeden[0]).then(() => {
                this.resetView();
            });
        });
    }

    public canLoeschen(): boolean {

        return (this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles()) &&
                this.schadenfall.status === TSSchadenfallStatus.NEU) ||

            (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAnlaufstelleRoleWithAdmins()) &&
                this.schadenfall.status === TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE) ||

            (this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles()) &&
                this.schadenfall.status === TSSchadenfallStatus.NEU_PAPIER_FS);
    }

    public schadenfallloeschen(): void {
        if (this.schadenfall) {
            this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
                text: 'SCHADENFALL_LOESCHEN_TEXT',
                title: 'SCHADENFALL_LOESCHEN',
            }).then(() => {   //User confirmed removal
                this.schadenfallModelManager.handleTransition(this.schadenfall, TSBemerkungScope.SCHADENFALL, undefined, '', TSSchadenfallEvent.LOESCHEN)
                    .then((response: any) => {
                        this.$state.go('schadenfaelle');
                    });
            }).catch(() => {
                console.error('error could not delete schadenfall');
            });
        }
    }

    private next() {
        this.errorService.clearAll();
        if (this.isGesuchValid() && this.model) {
            if (this.hasSchaeden()) {
                if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getRolesAllowedForAnlaufstellenPruefung()) && this.inBearbeitungAnlaufstelle()) {
                    this.triggerBearbeitungASDialog();
                } else if (this.freigebenGS()) {
                    //Freigabe Gesuchsteller
                    this.triggerFreigabedialogGesuchsteller();
                } else if (this.freigebenFS()) {
                    //Freigabe FS
                    this.triggerFreigabedialogFS();
                } else if (this.freigebenAnlaufstelle()) {
                    //Freigabe Anlaufstelle
                    this.triggerFreigabedialogAnlaufstelle();
                } else if (this.isInBearbeitungFSAblehnung()) {
                    //Ablehnung FS fuer Ablehnung
                    this.triggerFreigabedialogFSAblehnung();
                } else {
                    this.$log.info('no next state available for this fall in this role');
                }
            }
        }
    }

    private triggerBearbeitungASDialog() {
        //check mindestens ein schaetzer bevor wir dialog oeffnen ,ausserdem sollten die steuerdaten geprueft sein
        if (this.schadenfallEvent === TSSchadenfallEvent.ANLAUFSTELLE_BASISPRUEFUNG_OK) {
            if (!this.isSteuerdatenUndSchaetzerSet()) {
                return; //stop
            }
        }
        this.triggerGenericFreigabeDialog();
    }

    private isSteuerdatenUndSchaetzerSet(): boolean {
        if (this.schadenfall && (this.schadenfall.schaetzer === undefined || this.schadenfall.schaetzer.length === 0)) {
            this.$log.warn('showing error message because no schaetzer is assigned');
            this.errorService.addMesageAsError('ERROR_NO_SCHAETZER');
            return false;
        } else if (this.schadenfall && this.schadenfall.gesuchsteller &&
            this.schadenfall.gesuchsteller.rechtsform !== TSRechtsform.MEHRPERSONENGESELLSCHAFT &&
            this.schadenfall.gesuchsteller.finanzangaben &&
            !this.schadenfall.gesuchsteller.finanzangaben.steuerdatenGeprueft) {
            //wenn pruefung der steuerdaten nicht ok war
            this.errorService.addMesageAsError('ERROR_NO_STEUERDATENPRUEFUNG');
            return false;
        }
        return true;
    }

    private triggerAuftragSchaetzerDialog() {
        this.triggerGenericFreigabeDialog();
    }

    private triggerGenericFreigabeDialog(params?: any) {
        //use passed params or init default
        let dialogParams = params || {
            text: this.schadenfallEvent,
            begrundungscodeOptions: this.getBegrundungscodeOptions(),
            showBegruendung: true,
            showBemerkung: true,
        };
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController, dialogParams).then((response: any) => {
            if (response && this.schadenfallEvent) {
                this.schadenfallModelManager.handleTransition(this.model, TSBemerkungScope.SCHADENFALL, response.begruendung,
                    response.bemerkung, this.schadenfallEvent)
                    .then((response: any) => {
                        this.resetView();
                        let schadenfallIdParam: IFallStateParams = {schadenfallId: this.model.id};
                        this.$state.go('schaetzung', schadenfallIdParam);
                    });
            }
        }).catch(() => {
        });
    }

    private triggerFreigabedialogGesuchsteller() {
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController, {
            text: 'FREIGABE_BEMERKUNG_GESUCHSTELLER_TEXT',
            begrundungscodeOptions: this.getBegrundungscodeOptions(),
            showBegruendung: false,
            showBemerkung: false,
        }).then((response: any) => {
            if (response) {
                this.schadenfallModelManager.handleTransition(this.model, TSBemerkungScope.SCHADENFALL, response.begruendung,
                    response.bemerkung, TSSchadenfallEvent.GESUCH_DURCH_BEROFFENER_FREIGEGEBEN)
                    .then((response: any) => {
                        this.resetView();
                        this.$state.go('abschluss', {schadenfallId: this.model.id});
                    });
            }
        }).catch(() => {
        });
    }

    private triggerFreigabedialogAnlaufstelle() {
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController, {
            text: 'FREIGABE_BEMERKUNG_ANLAUFSTELLE_TEXT',
            showBegruendung: false,
            showBemerkung: false,
        }).then((response: any) => {
            if (response) {
                this.schadenfallModelManager.handleTransition(this.model, TSBemerkungScope.SCHADENFALL, response.begruendung,
                    response.bemerkung, TSSchadenfallEvent.PAPIERGESUCH_DURCH_ANLAUFSTELLE_FREIGEGEBEN)
                    .then((response: any) => {
                        this.resetView();
                        this.$state.go('schadenfaelle');
                    });
            }
        }).catch(() => {
        });
    }

    private triggerFreigabedialogFS() {
        //check mindestens ein schaetzer bevor wir dialog oeffnen ,ausserdem sollten die steuerdaten geprueft sein
        if (this.schadenfallEvent === TSSchadenfallEvent.FREIGABE_PAPIER_FS_6) {
            if (!this.isSteuerdatenUndSchaetzerSet()) {
                return; //stop
            }
        }

        this.triggerGenericFreigabeDialog({
            text: this.schadenfallEvent,
            showBegruendung: false,
            showBemerkung: false,
        });
    }

    private triggerFreigabedialogFSAblehnung() {
        this.triggerGenericFreigabeDialog();
    }

    public getViewTitle(): string {
        return this.dvBernUtil.getViewTitle(this.model);
    }

    public inBearbeitungAnlaufstelle(): boolean {
        //ANLAUFSTELLE_BASISPRUEFUNG_OK
        return this.schadenfall.status === TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE;
    }

    public getChecklistEntries(): Array<string> {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.checklistOptions;
        }
        return [];
    }

    public getBegrundungscodeOptions(): Array<TSBegruendungsCode> {
        if (this.statuswechsel !== undefined) {
            if (this.schadenfallEvent === undefined) {
                console.warn('Should have selected schadenfallEvent to trigger, otherwise allowed begruendugnscodes will not be set)');
                return [];
            } else {
                return this.statuswechsel.readBegruendungscodeOptions(this.schadenfallEvent);
            }
        }
        return [];
    }

    public getSchadenfallEvents() {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.possibleEvents;
        }
        return [];
    }

    public isFreigabeVisible(): boolean {
        //this could maybe be extracted to the service
        if (this.statuswechsel !== undefined) {

            let hasAllowedRole = this.authServiceRS.isOneOfRoles(this.statuswechsel.allowedRoles);
            let isOnRelevantPage = this.statuswechsel.visibleOnPage === this.$state.current.name;
            return hasAllowedRole && isOnRelevantPage && this.getSchadenfallEvents().length !== 0
        }
        return false;
    }

    public isFreigabeDisabled(): boolean {
        return this.checklistValid !== true;
    }

    public freigebenGS(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.NEU;
    }

    public freigebenAnlaufstelle(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE;
    }

    public freigebenFS(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.NEU_PAPIER_FS;
    }

    public isInBearbeitungFSAblehnung(): boolean {
        return this.schadenfall.status === TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS;
    }

    public checklistStatusChanged(allchecked: boolean): void {
        this.checklistValid = allchecked;
        if (!this.checklistValid) {
            this.schadenfallEvent = undefined;
        }
    }

    public showManuelleAnlaufstellenZuweisungFS(): boolean {
        return this.model.status === TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS;
    }

    public showSchaetzerZuweisung(): boolean {
        return (this.schadenfall.status !== TSSchadenfallStatus.NEU && this.schadenfall.status !== TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE) &&
            this.isSchadenFallVisible() && this.isEreignisSaved();
    }

    private loadPossibleSchaetzer() {
        if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAllowedToCreatePapierSchadenfallRoles())) {
            if (this.schadenfall && this.schadenfall.anlaufstelle) {
                this.anlaufstelleRS.getBenutzerOfAnlaufstelle(this.schadenfall.anlaufstelle.id, TSRole.ANLAUFSTELLE_SCHAETZER).then((response: any) => {
                    this.possibleSchaetzer = response;
                });
            } else {
                this.$log.debug('Not loading possible schaetzer because there is no anlaufstelle set', this.schadenfall)
            }
        }
    }

    public getAvailableSchaezter(): Array<TSBenutzer> {
        if (this.possibleSchaetzer !== undefined) {
            return this.possibleSchaetzer.filter((user: TSBenutzer) => {
                if (this.schadenfall.schaetzer && this.schadenfall.schaetzer.length !== 0) {
                    let index = DVBernUtil.getIndexOfElementwithID(user, this.schadenfall.schaetzer);
                    return index === -1;
                }
                return true;
            })
        }
        return [];
    }

    public getSchadenfallStatusList(): Array<TSSchadenfallStatus> {
        return getTSSchadenfallStatusalues();
    }

    public addSchaetzer() {
        if (this.selectedSchaetzer !== undefined) {
            this.schadenfallModelManager.addSchaetzer(this.selectedSchaetzer).then((response: any) => {
                this.selectedSchaetzer = undefined;
            });
        }
    }

    public removeSchaetzer(benutzer: TSBenutzer, event: any) {
        if (this.schadenfall.schaetzer && this.schadenfall.schaetzer.length !== 0) {
            this.schadenfallModelManager.removeSchaetzer(benutzer).then((response: any) => {
            });
        }
    }

    private updateStatus(): void {
        this.errorService.clearAll();
        this.dvDialog.showDialog(okCancelTemplate, OkCancelController, {
            title: 'STATUS_AKTUALISIEREN',
            text: 'STATUS_AKTUALISIEREN_TEXT',
        }).then(() => {
            this.schadenfallModelManager.updateStatus(this.model.status).then((schadResp: TSSchadenfall) => {
                this.initialModel = schadResp;
                this.model = angular.copy(schadResp);
                this.schadenfall = schadResp;
            });

        });
    }

    public displayEreignisButtonForFS(): boolean {
        return !(this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles()));
    }

    public displayEreignisButtonForGesuchsteller(): boolean {
        return (this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles()));
    }

    public isEreignisSaved(): boolean {
        return this.ereignisWasSaved;
    }

    public isOnlyOneSchadenVorhanden(): boolean {
        return this.model.schaeden.length <= 1;
    }

}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/schadenfallView/schadenfallView.ts